<template>
  <div class="create-journey-dialog__card-form-wrapper">
    <div
      class="create-journey-dialog__card-form create-journey-dialog__card-form--inputs"
      :class="{ 'is-resize-textarea': isResizeTextarea }"
    >
      <bh-text-input
        :value="journeyName"
        label="Title"
        class="create-journey-dialog__card-form-input"
        rounded-class="rounded"
        @input-text="$emit('update-field', 'journeyName', $event)"
        :force-rules="forceRules"
        :validate="true"
        :rules="[
          value => !!value || 'Required.',
          value => (value || '').length > 2 || 'Min 3 characters',
          value => (value || '').length <= 250 || 'Max 250 characters',
        ]"
      />
      <div class="create-journey-dialog__card-form-select-wrapper">
        <bh-select
          :enable-vuetify-options="true"
          :value="journeyDuration"
          label="Duration"
          select-label=""
          class="create-journey-dialog__card-form-select"
          rounded-class="rounded"
          :items="journeyDurationItems"
          item-text="text"
          item-value="value"
          append-icon="bhi-chevron-down"
          @input="$emit('update-field', 'journeyDuration', $event)"
          :hide-details="false"
          :validate="true"
          :rules="[durationRule]"
        />
        <bh-select
          :enable-vuetify-options="true"
          :value="positiveActionsFrequency"
          label="Positive Actions Frequency"
          select-label=""
          class="create-journey-dialog__card-form-select"
          rounded-class="rounded"
          :items="positiveActionsFrequencyItems"
          item-text="text"
          item-value="value"
          append-icon="bhi-chevron-down"
          @input="$emit('update-field', 'positiveActionsFrequency', $event)"
          :hide-details="false"
          :validate="true"
          :rules="[positiveActionsFrequencyRule]"
        />
        <bh-select
          :enable-vuetify-options="true"
          :value="journalFrequency"
          label="Journal Frequency"
          select-label=""
          class="create-journey-dialog__card-form-select"
          rounded-class="rounded"
          :items="journalFrequencyItems"
          item-text="text"
          item-value="value"
          append-icon="bhi-chevron-down"
          @input="$emit('update-field', 'journalFrequency', $event)"
          :hide-details="false"
          :validate="true"
          :rules="[journalFrequencyRule]"
        />
        <bh-select
          :enable-vuetify-options="true"
          :value="heroicChoiceFrequency"
          label="Heroic Choice Frequency"
          select-label=""
          class="create-journey-dialog__card-form-select"
          rounded-class="rounded"
          :items="heroicChoiceFrequencyItems"
          item-text="text"
          item-value="value"
          append-icon="bhi-chevron-down"
          :hide-details="false"
          @input="$emit('update-field', 'heroicChoiceFrequency', $event)"
        />
        <bh-select
          :enable-vuetify-options="true"
          :value="messageTime"
          label="Message Time"
          select-label=""
          class="create-journey-dialog__card-form-select"
          rounded-class="rounded"
          :items="messageTimeItems"
          item-text="text"
          item-value="value"
          append-icon="bhi-chevron-down"
          @input="$emit('update-field', 'messageTime', $event)"
          :hide-details="false"
          :validate="true"
          :rules="[messageTimeRule]"
        />
        <bh-select
          :enable-vuetify-options="true"
          :value="courseSteps"
          label="Course Steps"
          select-label=""
          class="create-journey-dialog__card-form-select"
          rounded-class="rounded"
          :items="courseStepsItems"
          item-text="text"
          item-value="value"
          append-icon="bhi-chevron-down"
          @input="$emit('update-field', 'courseSteps', $event)"
          :hide-details="false"
          :validate="true"
          :rules="[courseStepsRule]"
        />
      </div>
    </div>
    <div
      class="create-journey-dialog__card-form create-journey-dialog__card-form--textarea"
      :class="{ 'is-resize-textarea': isResizeTextarea }"
    >
      <bh-text-area
        :value="journeyDescription"
        class="create-journey-dialog__card-form-input create-journey-dialog__card-form-input--textarea"
        rounded-class="rounded"
        @input-text="$emit('update-field', 'journeyDescription', $event)"
        :force-rules="forceRules"
        :validate="true"
        :rules="[
          value => !!value || 'Required.',
          value => (value || '').length > 2 || 'Min 3 characters',
          value => (value || '').length <= 3000 || 'Max 3,000 characters',
        ]"
      />
      <div
        class="create-journey-dialog__card-form-input-actions blur-background"
      >
        <div class="create-journey-dialog__card-form-input-actions-label">
          <span>Description</span>
        </div>
        <div class="create-journey-dialog__card-form-input-actions-buttons">
          <v-btn icon color="black" @click="resizeTextarea()">
            <v-icon>bhi-resize</v-icon>
          </v-btn>
          <!-- TODO: Uncomment this when the microphone is ready -->
          <!-- <v-btn icon color="black" @click="toggleMicrophone()">
            <v-icon :class="{ 'bhi-microphone-active': isRecording }"
              >bhi-microphone</v-icon
            >
          </v-btn> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BhSelect from '@/components/inputs/BhSelect.vue'
import BhTextInput from '@/components/inputs/BhTextInput.vue'
import BhTextArea from '@/components/inputs/BhTextArea.vue'
export default {
  name: 'JourneyForm',
  components: {
    BhSelect,
    BhTextInput,
    BhTextArea,
  },
  data: () => ({
    isResizeTextarea: false,
    isRecording: false,
    recorder: null,
    audioLevel: 0,
    audioPackages: 0,
    lastAudioTime: null,
    isAudioDetected: false,
  }),
  props: {
    journeyName: {
      type: String,
      default: '',
    },
    journeyDuration: {
      type: [String, Number],
      default: '',
    },
    positiveActionsFrequency: {
      type: [String, Number],
      default: '',
    },
    journalFrequency: {
      type: [String, Number],
      default: '',
    },
    heroicChoiceFrequency: {
      type: [String, Number],
      default: '',
    },
    messageTime: {
      type: [String, Number],
      default: '',
    },
    courseSteps: {
      type: [String, Number],
      default: '',
    },
    journeyDescription: {
      type: String,
      default: '',
    },
    forceRules: {
      type: Boolean,
      default: false,
    },
    journeyDurationItems: {
      type: Array,
      default: () => [],
    },
    positiveActionsFrequencyItems: {
      type: Array,
      default: () => [],
    },
    journalFrequencyItems: {
      type: Array,
      default: () => [],
    },
    heroicChoiceFrequencyItems: {
      type: Array,
      default: () => [],
    },
    messageTimeItems: {
      type: Array,
      default: () => [],
    },
    courseStepsItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  methods: {
    durationRule(val) {
      if (val !== 'none') return true
      if (
        this.positiveActionsFrequency === 'none' &&
        this.messageTime === 'none' &&
        this.journalFrequency === 'none' &&
        this.courseSteps === 'none' &&
        val === 'none'
      ) {
        return 'Required'
      }

      if (
        (val === 'none' && this.positiveActionsFrequency !== 'none') ||
        (val === 'none' && this.messageTime !== 'none') ||
        (val === 'none' && this.journalFrequency !== 'none')
      ) {
        return 'Required'
      }

      return true
    },
    positiveActionsFrequencyRule(val) {
      if (val !== 'none') return true
      if (
        this.journeyDuration === 'none' &&
        this.messageTime === 'none' &&
        this.journalFrequency === 'none' &&
        this.courseSteps === 'none' &&
        val === 'none'
      ) {
        return 'Required'
      }

      if (
        val === 'none' &&
        this.journeyDuration !== 'none' &&
        this.journalFrequency === 'none' &&
        this.messageTime === 'none'
      ) {
        return 'Required'
      }

      return true
    },
    journalFrequencyRule(val) {
      if (val !== 'none') return true
      if (
        this.journeyDuration === 'none' &&
        this.positiveActionsFrequency === 'none' &&
        this.messageTime === 'none' &&
        this.courseSteps === 'none' &&
        val === 'none'
      ) {
        return 'Required'
      }

      if (
        this.messageTime !== 'none' ||
        (this.journeyDuration !== 'none' &&
          this.positiveActionsFrequency === 'none')
      ) {
        return 'Required'
      }

      return true
    },
    messageTimeRule(val) {
      if (val !== 'none') return true
      if (
        this.journeyDuration === 'none' &&
        this.positiveActionsFrequency === 'none' &&
        this.journalFrequency === 'none' &&
        this.courseSteps === 'none' &&
        val === 'none'
      ) {
        return 'Required'
      }

      if (
        this.journalFrequency !== 'none' ||
        (this.journeyDuration !== 'none' &&
          this.positiveActionsFrequency === 'none')
      ) {
        return 'Required'
      }

      return true
    },
    courseStepsRule(val) {
      if (val !== 'none') return true
      if (
        this.journeyDuration === 'none' &&
        this.positiveActionsFrequency === 'none' &&
        this.journalFrequency === 'none' &&
        this.messageTime === 'none' &&
        val === 'none'
      ) {
        return 'Required'
      }

      return true
    },
    resizeTextarea() {
      this.isResizeTextarea = !this.isResizeTextarea
    },
    onChangeSelect(name, value) {
      this.$emit('update-field', name, value)
    },

    // TODO: Uncomment this when the microphone is ready
    // async toggleMicrophone() {
    //   if (this.isRecording) {
    //     this.stopRecording()
    //   } else {
    //     try {
    //       this.recorder = await this.startRecordingMock()
    //       this.isRecording = true
    //     } catch (err) {
    //       console.error('❌ Microphone:', err.message)
    //       alert(err.message)
    //     }
    //   }
    // },

    // async startRecordingMock() {
    //   let audioCtx, source, workletNode, stream

    //   try {
    //     stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    //   } catch (err) {
    //     if (err.name === 'NotAllowedError') {
    //       throw new Error('No access to microphone - allow in browser.')
    //     } else if (err.name === 'NotFoundError') {
    //       throw new Error('Microphone not found in system.')
    //     } else {
    //       throw new Error('Error getting access to microphone.')
    //     }
    //   }

    //   audioCtx = new AudioContext({ sampleRate: 16000 })

    //   // Load and add the AudioWorklet module
    //   try {
    //     await audioCtx.audioWorklet.addModule('/audio-processor.js')
    //   } catch (error) {
    //     console.error('Failed to load audio worklet:', error)
    //     throw new Error('Failed to initialize audio processor')
    //   }

    //   source = audioCtx.createMediaStreamSource(stream)
    //   workletNode = new AudioWorkletNode(audioCtx, 'audio-processor')

    //   // Handle audio data from the worklet
    //   workletNode.port.onmessage = event => {
    //     if (event.data.type === 'audioData') {
    //       const inputData = event.data.data
    //       const pcm = this.convertFloat32ToInt16(inputData)

    //       // Calculate audio level for monitoring
    //       const rms = Math.sqrt(
    //         inputData.reduce((sum, val) => sum + val * val, 0) /
    //           inputData.length,
    //       )
    //       this.audioLevel = Math.min(100, rms * 1000) // Scale to 0-100

    //       // Update monitoring variables
    //       this.audioPackages++
    //       this.lastAudioTime = new Date()
    //       this.isAudioDetected = this.audioLevel > 1 // Threshold for audio detection

    //       // mock simulation API
    //       if (Math.random() > 0.95) {
    //         const mockText = 'This is a mock transcription.'

    //         this.$emit(
    //           'update-field',
    //           'journeyDescription',
    //           (this.journeyDescription || '') + ' ' + mockText,
    //         )
    //       }
    //     }
    //   }

    //   source.connect(workletNode)
    //   workletNode.connect(audioCtx.destination)

    //   return { audioCtx, source, workletNode, stream }
    // },

    // stopRecording() {
    //   if (this.recorder) {
    //     const { audioCtx, source, workletNode, stream } = this.recorder
    //     if (workletNode) workletNode.disconnect()
    //     if (source) source.disconnect()
    //     if (audioCtx) audioCtx.close()
    //     if (stream) stream.getTracks().forEach(track => track.stop())
    //     this.recorder = null
    //   }
    //   this.isRecording = false

    //   // Reset monitoring variables
    //   this.audioLevel = 0
    //   this.audioPackages = 0
    //   this.lastAudioTime = null
    //   this.isAudioDetected = false
    // },

    // convertFloat32ToInt16(float32Array) {
    //   const int16Array = new Int16Array(float32Array.length)
    //   for (let i = 0; i < float32Array.length; i++) {
    //     const s = Math.max(-1, Math.min(1, float32Array[i]))
    //     int16Array[i] = s < 0 ? s * 0x8000 : s * 0x7fff
    //   }
    //   return int16Array
    // },
  },
  watch: {
    journeyDuration: function() {
      this.$emit('trigger-validation')
    },
    positiveActionsFrequency: function() {
      this.$emit('trigger-validation')
    },
    journalFrequency: function() {
      this.$emit('trigger-validation')
    },
    messageTime: function() {
      this.$emit('trigger-validation')
    },
    courseSteps: function() {
      this.$emit('trigger-validation')
    },
  },
}
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.create-journey-dialog {
  &__card-form {
    width: 100%;
    position: relative;

    &--inputs {
      flex-shrink: 0;
      width: 50%;

      &.is-resize-textarea {
        display: none;
      }
    }
    &-wrapper {
      display: flex;
      flex-direction: row;
      gap: 16px;
      width: 100%;
      margin-top: 24px;
    }
    &-input {
      width: 100%;
      &--textarea {
        height: 100%;
      }
    }
    &-select-wrapper {
      display: flex;
      flex-direction: column;
    }
    &-select {
      .v-select {
        .v-input__slot {
          background-color: $bh-gray--6;
          border-radius: 8px;
          padding: 0 16px;
          &::before {
            content: none;
          }
        }

        &.error--text .v-input__slot {
          border-color: $bh-red;
        }
      }
    }
    &-input-actions {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% - 16px);
      z-index: 10;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding-left: 16px;

      &.blur-background {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        backdrop-filter: blur(16px);
      }

      .v-btn {
        &:before {
          content: none;
        }
      }
      &-label {
        font-size: 0.857rem;
        line-height: 1.6667;
        color: $bh-black;
        font-weight: 700;
      }
      &-buttons {
        display: flex;
        flex-direction: row;
      }
    }

    &--textarea {
      margin-top: 22px;
      flex-grow: 1;

      &.is-resize-textarea {
        min-height: 350px;
      }
    }
    textarea {
      width: 100%;
      resize: none !important;
      background-color: $bh-gray--6;
      padding-top: 48px;
    }
    .bh-text-area {
      height: 100%;

      textarea {
        height: 100%;
        max-height: 100%;
      }
    }
    .bh-text-input {
      &__input {
        border: 1px solid transparent;
        background-color: $bh-gray--6;
        border-radius: 8px;
        &:focus {
          background-color: $bh-white;
          border-color: $bh-blue;
        }
      }
    }
    .bhi-microphone-active {
      color: $bh-blue !important;
    }
  }
}
</style>
